<template>
	<section>
		<div class="panel-wrapper">
			<div class="filters-section">
				<div class="container">
					<div class="row">
						<div class="col-md-4 col-sm-12" v-for="filter in filters" :key="filter.id">
							<Multiselect
								:ref="filter.id"
								:groups="filter.groups"
								:choices="filter.choices"
								:filterName="filter.id"
								:placeholder="filter.placeholder"
								@change="updateSelectedFilters"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			SELECTED VALUES:<br />
			<pre>{{ output }}</pre>
		</div>
	</section>
</template>

<script>
import { defineComponent } from 'vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import Multiselect from '@/components/schreg-common/Multiselect.vue';

export default defineComponent({
	name: 'MultiselectTestComponent',
	components: {
		Multiselect
	},
	config: {
		key: 'schreg.testMultiselect',
		devPath: 'multiselect-test',
		exported: false
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			filters: [],
			output: []
		};
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'ClubsStore', 'UrlStore', 'ProfileStore', 'ProspectProfileStore']);
		const _filters = [];

		for (let filter = 1; filter <= 8; filter++) {
			_filters.push(this.buildFilter(filter));
		}
		this.filters = _filters;
	},
	methods: {
		completeMounting() {

		},
		buildFilter(id) {
			if (id === 3) {
				return this.buildGroupFilter(id, [5, 5, 5]);
			}
			if (id === 4) {
				return this.buildGroupFilter(id, [15]);
			}

			return {
				groups: [{
					name: null,
					choices: id === 2 ? [] : this.buildChoices(1, 30)
				}],
				id: `filter${id}`,
				placeholder: `Filter ${id}`
			};
		},

		buildGroupFilter(id, groupsDef) {
			const groups = [];
			let group = 1;
			let groupStart = 1;
			let groupEnd = 1;

			for (let totalThisGroup of groupsDef) {
				groupEnd = groupStart + (totalThisGroup - 1);

				groups.push({
					//id: null,
					name: `Group ${group}`,
					choices: this.buildChoices(groupStart, groupEnd)
				});

				group++;
				groupStart = groupEnd + 1;
			}

			return {
				groups: groups,
				id: `filter${id}`,
				placeholder: `Filter ${id}`
			};
		},

		buildChoices(from, to) {
			const choices = [];
			for (let choice = from; choice <= to; choice++) {
				choices.push({
					//id: null,
					enabled: choice !== 3,
					visible: choice !== 4,
					name: `Choice ${choice}`,
					html: choice === 2 ? `<b style="color:red;">Choice ${choice}</b>` : null,
					value: `VALUE_${choice}`,
					selected: false
				});
			}
			return choices;
		},

		updateSelectedFilters() { //filterId
			const _output = [];
			for (let filter of this.filters) {
				let ref = this.$refs[filter.id];
				if (ref.length) ref = ref[0];
				const _values = ref.getSelectedValues();
				if (_values.length > 0) {
					_output.push({
						filter: `${filter.placeholder} (${filter.id})`,
						values: ref.getSelectedValues()
					});
				}
			}

			this.output = _output;
		}
	}
});
</script>

<style lang="scss" scoped>
.filters-section {
	.container {
		padding-top: 1.5rem;
		padding-bottom: .75rem;
	}
	.col-md-4 {
		margin-bottom:0.75rem;
	}
}
</style>
